export default __webpack_public_path__ + "static/media/ReadexPro-Medium.9ea07d76.ttf";